import { BasicRoute, BasicRouteProps } from './BasicRoute';

import { AuthService } from '@services/AuthService/AuthService';

interface MfaRouteProps
    extends Omit<
        BasicRouteProps,
        'condition' | 'loading' | 'redirectTo' | 'users'
    > {}

export const MfaRoute = ({ ...routeProps }: MfaRouteProps) => {
    const mfaMetadata = AuthService.getMfaMetadata();

    return (
        <BasicRoute
            {...routeProps}
            condition={!!mfaMetadata}
            redirectTo="/"
            users={['notLogged', 'guest']}
        />
    );
};
